import { render, staticRenderFns } from "./SalesRampaign.vue?vue&type=template&id=082a9216&scoped=true"
import script from "./SalesRampaign.vue?vue&type=script&lang=js"
export * from "./SalesRampaign.vue?vue&type=script&lang=js"
import style0 from "./SalesRampaign.vue?vue&type=style&index=0&id=082a9216&prod&lang=less&scoped=true"
import style1 from "./SalesRampaign.vue?vue&type=style&index=1&id=082a9216&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082a9216",
  null
  
)

export default component.exports